module.exports = __webpack_public_path__ + "static/media/about4.961ed977.png";